import { SubmissionArgs } from '@sky-distribution/gp-onboarding-policy-service';
import {
  getDefaultCoverages,
  getDefaultDwellingCoverages,
} from '../config/defaultDwellingVariant';

export const prepareSubmissionForm = (
  data: Partial<SubmissionArgs>,
): SubmissionArgs | undefined => {
  const variant = data.variants?.[0];

  if (!variant || !('dwelling' in variant && variant.dwelling)) {
    return undefined;
  }

  const { propertyValue, dwellingCoverages, ...rest } = variant.dwelling;

  const movablesValue = `${Math.round((Number(propertyValue) * 0.10))
    .toFixed(2)}`;
  const updatedDwellingCoverages = getDefaultDwellingCoverages(
    propertyValue,
    movablesValue,
    dwellingCoverages,
  );

  return {
    baseData: {
      ...data.baseData,
    },
    variants: [
      {
        ...data.variants?.[0],
        dwelling: {
          ...rest,
          propertyValue,
          movablesValue,
          dwellingCoverages: updatedDwellingCoverages,
        },
        coverages: getDefaultCoverages(variant.coverages),
      },
    ],
    discount: data.discount,
  } as SubmissionArgs;
};
